import { useState, type ReactNode } from 'react';
import Caret from './Caret';

interface AccordionProps {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
}

export default function Accordion({ title, defaultOpen = true, children }: AccordionProps) {
  const [open, setOpen] = useState(!!defaultOpen);
  return (
    <section
      className={`border-2 border-primary rounded-xl overflow-hidden bg-card`}
    >
      <button
        type="button"
        className={`w-full text-left border-0 p-4 flex justify-between items-center cursor-pointer font-bold text-base ${
          open
            ? 'bg-card text-primary'
            : 'bg-primary text-primary-foreground'
        }`}
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span>{title}</span>
        <span
          className={`flex items-center transition-transform duration-150 ease-in-out ${
            open ? 'rotate-180 text-primary' : 'text-white'
          }`}
          aria-hidden
        >
          <Caret up={false} />
        </span>
      </button>
      {open && (
        <div className="px-4 pt-6 pb-12 bg-card">{children}</div>
      )}
    </section>
  );
}
